export const addressErrorMessages = {
  street: 'The street address entered is invalid',
  building: 'The building entered is invalid',
  postalCode: 'The postal code entered is invalid',
  suburb: {
    invalidSuburb: 'The suburb entered is invalid',
    invalidPostalCode: 'Please provide a valid postal code and then select suburb.',
  },
  city: 'The city / town entered is invalid',
  province: 'The province entered is invalid',
};
